function GetValidFileName(filename) {	
	var newFileName = filename.replace(/(\W+)/gi, '');
	if (newFileName.length > 200) {
		newFileName = newFileName.substring(0,200);
	}
	return newFileName;
}
export default GetValidFileName;